import propTypes from 'prop-types';

import Sidebar from './GuestSidebar';

function GuestDashboardContainer({ activeSidebarItem, children }) {
  return (
    <>
      <Sidebar activeItem={activeSidebarItem} />

      <div className="min-h-screen pt-6 md:pt-0 md:2xl:pl-80 md:xl:pl-80 md:pl-72 mx-6 py-7">
        {children}
      </div>
    </>
  );
}

GuestDashboardContainer.propTypes = {
  activeSidebarItem: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
};

export default GuestDashboardContainer;
